import { render, staticRenderFns } from "./DetailPagesMake.vue?vue&type=template&id=4ac39939&scoped=true&"
import script from "./DetailPagesMake.vue?vue&type=script&lang=js&"
export * from "./DetailPagesMake.vue?vue&type=script&lang=js&"
import style0 from "./DetailPagesMake.vue?vue&type=style&index=0&id=4ac39939&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac39939",
  null
  
)

export default component.exports